import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

/**
 * This is the button to open the app.
 * It also contains a dialog that opens, this shows the user
 * a link to download the app.
 */
@customElement("app-button")
export class AppButton extends LitElement {
    public static styles = css`
        button {
            font-family: "Onesize";
            color: white;
            background-color: #7f6ed7;
            border: 1px solid #332c57;
            padding: 5px 10px;
            margin: 0 0 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
            font-size: 20px;
        }

        button:hover,
        button:active {
            background-color: #332c57;
        }

        a,
        a:visited {
            color: #7f6ed7;
        }

        #appdialog {
            max-width: 400px;
            border: 1px solid #332c57;

            &::backdrop {
                backdrop-filter: blur(5px);
            }
        }
    `;

    public render(): unknown {
        return html`
            <button @click="${this.openApp}">Open app</button>
            <dialog id="appdialog">
                <p>
                    If the app doesn't open, download it via
                    <a target="_blank" href="https://testflight.apple.com/join/Hw6mjIad">Testflight</a>
                </p>

                <button @click="${(): void => this.dialog()?.close()}">Close</button>
            </dialog>
        `;
    }

    /** Try to open the app */
    private openApp(): void {
        // Link to the deep link
        window.location.href = `thegameapp://start?session=${localStorage.getItem("playerSessionId")}`;
        // Show the download dialog.
        this.dialog()?.showModal();
    }

    /** Get the dialog element */
    private dialog: () => HTMLDialogElement | null = () => this.renderRoot.querySelector("#appdialog");
}
